// React
import { useCallback } from 'react'

// Models
import { useStores } from 'models'

// Interfaces
import {
  IAssessmentCompetencyUnitGetDetailAttrs,
  IAssessmentCompetencyUnitDownloadDocumentAttrs,
} from 'interfaces/back-office/assessment/registration/competency-unit/competency-unit-view.interface'

const useAssessmentCompetencyUnit = () => {
  // Hook
  const {
    assessmentCompetencyUnit: {
      assessmentCompetencyUnit_loading,
      assessmentCompetencyUnit_detail,
      assessmentCompetencyUnit_CLEAR_DETAIL,
      assessmentCompetencyUnit_fetchDetail: fetchDetail,
      assessmentCompetencyUnit_downloadDocument: downloadDocument,
    },
  } = useStores()

  /**
   * @description Fetch assessment competency unit detail
   *
   * @param {IAssessmentCompetencyUnitGetDetailAttrs} payload
   *
   * @return {Promise<void>} Promise<void>
   */
  const assessmentCompetencyUnit_fetchDetail = useCallback(
    (payload: IAssessmentCompetencyUnitGetDetailAttrs): Promise<void> => {
      return new Promise((resolve, reject) => {
        fetchDetail({
          params: { ...payload.params },
          body: { ...payload.body },
          requestConfig: { ...payload.requestConfig },
          onSuccess: resolve,
          onError: reject,
        })
      })
    },
    [fetchDetail],
  )

  /**
   * @description Download assessment competency unit document
   *
   * @param {IAssessmentCompetencyUnitDownloadDocumentAttrs} payload
   *
   * @return {Promise<void>} Promise<void>
   */
  const assessmentCompetencyUnit_downloadDocument = useCallback(
    (payload: IAssessmentCompetencyUnitDownloadDocumentAttrs): Promise<void> => {
      return new Promise((resolve, reject) => {
        downloadDocument({
          params: { ...payload.params },
          requestConfig: { ...payload.requestConfig },
          onSuccess: resolve,
          onError: reject,
        })
      })
    },
    [downloadDocument],
  )

  return {
    assessmentCompetencyUnit_loading,
    assessmentCompetencyUnit_detail,
    assessmentCompetencyUnit_CLEAR_DETAIL,
    assessmentCompetencyUnit_fetchDetail,
    assessmentCompetencyUnit_downloadDocument,
  }
}

export { useAssessmentCompetencyUnit }
